import CommonCardModel from "./commonCard.model"
import PosterImageModel from "./posterImage.model"
import { MediaType } from "../../utils/enums"

export default class ResourceCardModel extends CommonCardModel {
    constructor(
        public additionalFeatures: string[],
        public brand: string | null,
        public canonicalUrl: string,
        public description: string,
        public duration: string,
        public grades: string[],
        public guid: string,
        public mediaType: MediaType,
        public posterImages: PosterImageModel[],
        public supportMaterials: string[],
        public title: string,
        public type: string = "resource"
    ) {
        super(brand, canonicalUrl, description, grades, posterImages, title, type)
    }

    public static fromData(res) {
        const mediaType: MediaType = res.media_type[0]
        const posterImages: PosterImageModel[] = res.poster_images.map(
            (image: any) => new PosterImageModel(image.type, image.alt_text, image.url)
        )

        return new ResourceCardModel(
            res.additional_features,
            res.brand,
            res.canonical_url,
            res.description,
            res.duration,
            res.grades,
            res.guid,
            mediaType,
            posterImages,
            res.support_materials,
            res.title
        )
    }
}
